import { createSelector } from "reselect";

const selectGyms = state => state.schAttenReducer.gyms||[];
const selectCurrentRoom = state => state.schAttenReducer.currentRoom;

//Возвращает obj сотрудника по guid
export const getStaffByGuid = (guid) => createSelector(
    selectGyms, 
    (gyms) => {
        for (var i=0;i<gyms.length;i++) {
            var staff = gyms[i].staff.find(item => item.guid === guid);
            if (staff) {
                return staff; 
            }
        };
        return { guid:"", name:"", src:"", post:"" };
    }
);

//Возвращает массив сотрудников по guid помещения
export const getAllStaffByRoom = (roomGuid) => createSelector(
    selectGyms, 
    (gyms) => {
        for (var i=0;i<gyms.length;i++) {
            var room = gyms[i].rooms.find(item => item.guid === roomGuid);
            if (room) {
                return gyms[i].staff; 
            }
        }
    }
);

//Возвращает массив шаблонов диапозонов времени
export const getTimeTmpltByRoom = (roomGuid) => createSelector(
    selectGyms, 
    (gyms) => {
        for (var i=0;i<gyms.length;i++) {
            var gym = gyms[i].rooms.find(item => item.guid === roomGuid);
            if (gym) return gyms[i].timeTmplt; 
        }
        return [];
    }
);

//Возвращает timezone помещения
export const getTimeZoneByRoom = (roomGuid) => createSelector(
    selectGyms, 
    (gyms) => {
        for (var i=0;i<gyms.length;i++) {
            var gym = gyms[i].rooms.find(item => item.guid === roomGuid);
            if (gym) return gyms[i].timezone; 
        }
        return [];
    }
);



export const selectRooms = createSelector(
    selectGyms,
    (gyms) => {
        let rooms = [];
        gyms.forEach(element => {
            rooms=rooms.concat(element.rooms);
        });
        return rooms;
    }
);


export const selectGymByRoom = createSelector(
    [selectGyms,selectCurrentRoom],
    (gyms,room) => {
        let roomGym = gyms[0];
        gyms.forEach(gym => {
            if (gym.rooms.find(item => item.guid === room)) roomGym=gym;
        });
        
        return roomGym;
    }
);

export const selectStaff = createSelector(
    selectGymByRoom,
    (gym) => gym.staff
);

